module.exports = __webpack_public_path__ + "img/icon_login_white.587e3fe8.svg";